export { default as Investor } from './screen/Investor';
export { default as UpdateInvestor } from './screen/UpdateInvestor';